export default __webpack_public_path__ + "static/media/icon-invoice.d24214e2.svg";